import React from 'react'
import Box from '@mui/material/Box'
import NextLink from 'next/link'
import { useMobile, EmtModal, EmtTypography } from 'emt-components-v2'
import { Routes } from '@/assets/configs'
import SignUpDetailsFormContent from '@/components/SignUp/SignUpDetailsFormContent'

type SignUpModalProps = {
  open: boolean
  onClose: () => void
  title?: string
  subtitle?: React.ReactNode
  type?: string
  color?: 'purple' | 'pink' | 'blue' | string
}

/**
 * Full signup modal (content included) + scroll lock.
 * - Prevents background scroll on iOS/Android/desktop.
 * - Restores scroll position on close.
 */
export const SignUpModal: React.FC<SignUpModalProps> = ({
  open,
  onClose,
  title = 'S’inscrire pour contacter les pet sitters',
  subtitle,
  type = 'dogowner',
  color = 'purple',
}) => {
  const [isMobile] = useMobile()

  return (
    <EmtModal
      open={open}
      onClose={onClose}
      sx={{
        zIndex: 1201,
        '& .inner-box': {
          width: '800px',
          maxWidth: isMobile ? '100vw' : '90vw',
          backgroundColor: '#F9F9F9',
          ...(isMobile
            ? {
                transform: 'translate(-50%, 0)',
                bottom: '0',
                height: '90vh',
                top: 'unset',
                borderRadius: '24px 24px 0 0',
                position: 'fixed',
              }
            : {}),
        },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <EmtTypography variant="h3" fontWeight="800" marginTop="10px" sx={{ fontSize: isMobile ? '24px' : '34px' }}>
          {title}
        </EmtTypography>

        {subtitle ?? (
          <EmtTypography variant="body1" fontWeight="700">
            {'Déjà inscrit ? '}
            <NextLink href={Routes.Connection.SignIn} passHref legacyBehavior>
              <span style={{ textDecoration: 'underline', cursor: 'pointer', color: '#AE59C6' }}>Connectez-vous</span>
            </NextLink>
          </EmtTypography>
        )}

        <SignUpDetailsFormContent type={type as string} fakeAnimal color={color} buttonSticky={true} />
      </Box>
    </EmtModal>
  )
}

export default SignUpModal
